import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { LOGO_URL } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { LogOut, Search, User as UserIcon, LayoutDashboard, Heart, Sparkles } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator
} from "./ui/dropdown-menu";
import LoginDialog from "./LoginDialog";

const Header = () => {
  const { user, logout } = useAuth();
  const [openLogin, setOpenLogin] = React.useState(false);
  const navigate = useNavigate();

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 bg-[#FAF9F6]/85 backdrop-blur-xl border-b border-[#E5E2D9]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3">
          <img src={LOGO_URL} alt="Secret Angels" className="h-14 w-14 object-contain" />
          <div className="hidden sm:block leading-tight">
            <div className="font-serif text-xl tracking-[0.25em] text-[#1A2118]">SECRET</div>
            <div className="font-serif text-xl tracking-[0.25em] text-[#1A2118] -mt-1">ANGELS</div>
          </div>
        </Link>

        <div className="flex items-center gap-2">
          {user ? (
            <DropdownMenu>
              <DropdownMenuTrigger
                data-testid="user-menu-trigger"
                className="flex items-center gap-2 px-3 py-2 rounded-full hover:bg-[#F3F1EA] transition"
              >
                {user.picture ? (
                  <img src={user.picture} alt={user.name} className="h-8 w-8 rounded-full object-cover" />
                ) : (
                  <UserIcon size={20} strokeWidth={1.5} />
                )}
                <span className="hidden sm:block text-sm">{user.name?.split(" ")[0]}</span>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-56">
                {user.role === "admin" && (
                  <DropdownMenuItem data-testid="menu-admin" onClick={() => navigate("/admin")}>
                    <LayoutDashboard className="mr-2 h-4 w-4" /> Panel Admin
                  </DropdownMenuItem>
                )}
                {user.role === "model" && (
                  <DropdownMenuItem data-testid="menu-model-dashboard" onClick={() => navigate("/dashboard/model")}>
                    <Sparkles className="mr-2 h-4 w-4" /> Mi Perfil Angel
                  </DropdownMenuItem>
                )}
                {user.role === "client" && (
                  <DropdownMenuItem data-testid="menu-client-dashboard" onClick={() => navigate("/dashboard")}>
                    <Heart className="mr-2 h-4 w-4" /> Mi Feed
                  </DropdownMenuItem>
                )}
                <DropdownMenuSeparator />
                <DropdownMenuItem data-testid="menu-logout" onClick={async () => { await logout(); navigate("/"); }}>
                  <LogOut className="mr-2 h-4 w-4" /> Cerrar sesión
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          ) : (
            <button
              data-testid="open-login"
              onClick={() => setOpenLogin(true)}
              className="btn-primary text-sm"
            >
              Iniciar Sesión
            </button>
          )}
        </div>
      </div>

      <LoginDialog open={openLogin} onOpenChange={setOpenLogin} />
    </header>
  );
};

export default Header;
